import React from 'react';
import {
  RequestFormVisibility,
  useEmployeeRequestFormsQuery,
} from '../../../__generated__/graphql';
import { RequestForm } from '../RequestForm';
import { isSelectableInNewRequest } from '../isSelectableInNewRequest';

type Props = {
  show: boolean;
  recordType: string;
  showAllRequests: boolean;
  onHide: () => void;
};

export const EmployeeRequestForm: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  const { data, loading } = useEmployeeRequestFormsQuery({
    skip: !props.show,
  });

  const requestFormsVisibleForEmployee =
    data?.requestForms.filter(
      (form) =>
        (form.flair__Visibility__c === RequestFormVisibility.HrEmployee ||
          form.flair__Visibility__c ===
            RequestFormVisibility.HrManagerEmployee) &&
        isSelectableInNewRequest(form),
    ) ?? [];

  return (
    <RequestForm
      {...props}
      requestForms={requestFormsVisibleForEmployee}
      employees={[]}
      isSelectEmployeeStepVisible={false}
      loading={loading}
    />
  );
};
